import { apiRequest } from './apiClient';

export async function getStudentProfile() {
  const response = await apiRequest('/student/me');

  return response.data;
}

export async function getAcademicCounts() {
  const response = await apiRequest('/student/academic-counts');

  return response.data || {
    homeworks: 0,
    exams: 0,
    challenges: 0,
    notifications: 0,
    total: 0,
  };
}
